import { Button, Card,Input,notification} from 'antd';
import {CopyOutlined } from '@ant-design/icons';
import {useIntl } from 'react-intl';

const ShareLink = ()=>{
    const intl = useIntl();

    const openNotification = (placement:any ) => {
        notification.success({
            message:intl.formatMessage({id: 'share.link.copy.message', defaultMessage:'Copiado!'}),
            placement,
            duration: 3
        });
      };

    const onClick = () => {
        navigator.clipboard.writeText(window.location.href);
        openNotification('bottomRight');
    };

    return (
    <Card>
        <Input.Group style={{display:'flex', flexDirection:'row'}}>
        <Input readOnly addonAfter={
                <Button icon={<CopyOutlined />} style={{border:'none', backgroundColor:'transparent', width:36, height: 30}} onClick={onClick}/>
        } value={window.location.href} style={{width:'350px', fontSize:'small'}} />
        </Input.Group>
    </Card>)
}
export default ShareLink;